import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useQuery } from "@tanstack/react-query";
import {
  getActivities,
  getActivityFAQ,
  getActivityTermsConditions,
} from "../../../../../services/activityService";

export const CopyFromActivityModal = ({
  open,
  onClose,
  onSelectFAQ,
  onSelectTerms,
  mode = "faq",
  excludeActivityId = null,
}) => {
  const { data: listData, isLoading } = useQuery({
    queryKey: ["activities", 1, "", ""],
    queryFn: () => getActivities(1, {}),
    enabled: open,
  });

  const items = (listData?.data?.data || []).filter(
    (activity) =>
      excludeActivityId == null ||
      Number(activity.id) !== Number(excludeActivityId)
  );

  const handlePick = async (id) => {
    if (mode === "faq") {
      const res = await getActivityFAQ(id);
      const faqs = Array.isArray(res?.data) ? res.data : res?.data?.faqs || [];
      onSelectFAQ?.(faqs.map((f) => ({ question: f.question, answer: f.answer })));
    } else {
      const res = await getActivityTermsConditions(id);
      const raw = res?.data;
      const list = Array.isArray(raw?.terms_and_conditions)
        ? raw.terms_and_conditions
        : raw
        ? [raw]
        : [];
      onSelectTerms?.(list[0]?.terms_and_conditions || "");
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[60]">
      <div className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
          <DialogTitle className="text-lg font-bold text-gray-900">
            {mode === "faq" ? "Copy FAQs from activity" : "Copy terms from activity"}
          </DialogTitle>
          <div className="mt-4 max-h-64 space-y-2 overflow-y-auto">
            {isLoading ? (
              <p className="text-sm text-gray-500">Loading...</p>
            ) : items.length === 0 ? (
              <p className="text-sm text-gray-500">No other activities found.</p>
            ) : (
              items.map((a) => (
                <button
                  key={a.id}
                  type="button"
                  onClick={() => handlePick(a.id)}
                  className="w-full rounded-lg border border-gray-200 px-4 py-3 text-left text-sm hover:bg-gray-50"
                >
                  {a.name}
                </button>
              ))
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="mt-4 w-full rounded-lg border border-gray-200 py-2 text-sm font-medium"
          >
            Cancel
          </button>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
